"use client"

import { HomePageLayout } from "@/components/website/homepage-layout"

export default function CookiePolicyPage() {
  return (
    <HomePageLayout>
      <div className="container mx-auto px-4 py-6 space-y-4">
        <h1 className="text-2xl font-bold">Cookie Policy</h1>
        <p className="text-sm text-muted-foreground">
          This Cookie Policy explains how Oxygen Tamil News uses cookies and similar technologies when you visit our website or use our services.
        </p>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">What are cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device when you visit a website. They help the site remember your preferences,
            understand how you use our pages, and improve your overall experience.
          </p>
        </section>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">How we use cookies</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To keep the site secure and functioning correctly.</li>
            <li>To remember basic preferences such as language or display settings.</li>
            <li>To understand aggregated traffic patterns and improve content and navigation.</li>
          </ul>
        </section>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">Managing cookies</h2>
          <p>
            Most browsers allow you to control cookies through their settings, including blocking or deleting them. If you choose to disable cookies,
            some features of the website may not work as intended.
          </p>
        </section>
      </div>
    </HomePageLayout>
  )
}


